


// Cakes.js
import React, { useEffect, useState } from 'react';
import CakeCategory from './Features/CakeCategory';
import CakeList from './Features/CakeList';
import Navbar from '../nav';
import axiosInstance from '../../utils/axiosInstance';
import ProductSkeleton from '../../utils/ProductSkeleton';
import Breadcrumbs from '../../utils/Breadcrumb';

const Cakecomponent = () => {
  const [cakesData, setCakesData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Display the loading skeleton while waiting for the response
    const timeoutId = setTimeout(() => {
      setLoading(true);
    }, 800); // Set a delay to show the loading skeleton after 300 milliseconds

    // Fetch products from the API using axiosInstance directly
    axiosInstance.get('/api/products/getcakes')
      .then((response) => {
        clearTimeout(timeoutId); // Clear the timeout to prevent the loading skeleton if the response comes quickly
        setCakesData(response.data);
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((error) => {
        clearTimeout(timeoutId); // Clear the timeout in case of an error
        console.error('Error fetching cakes:', error);
        setError(error); // Set error state in case of an error
        setLoading(false); // Set loading to false in case of an error
      });
  }, []);

  const categories = Array.from(new Set(cakesData.map((cake) => cake.category)));
  const filteredCakes =
    selectedCategory === 'All'
      ? cakesData
      : cakesData.filter((cake) => cake.category === selectedCategory);

  return (
    <>
      <Navbar />
      <Breadcrumbs />

      <div>
        <CakeCategory
          onSelectCategory={setSelectedCategory}
          selectedCategory={selectedCategory}
          categories={categories}
        />
        {loading ? (
        <ProductSkeleton /> // Display the loading skeleton while data is being fetched
      ) : error ? (
        <p>Error loading cakes. Please try again later.</p> // Display an error message if there is an error
      ) : (
        <>
          <CakeList cakes={filteredCakes} />
        </>
      )}
      </div>
    </>
  );
};

export default Cakecomponent;
